import { render, staticRenderFns } from "./LengthsManagement.vue?vue&type=template&id=33208fd2&scoped=true"
import script from "./LengthsManagement.vue?vue&type=script&lang=js"
export * from "./LengthsManagement.vue?vue&type=script&lang=js"
import style0 from "./LengthsManagement.vue?vue&type=style&index=0&id=33208fd2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33208fd2",
  null
  
)

export default component.exports